import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'USA_SCREEN_APP_DETAIL',
        create: 'USA_SCREEN_APP_CREATE',
        update: 'USA_SCREEN_APP_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      }
    };
  },
  computed: {
    setting: function setting() {
      var _this = this;

      var h = this.$createElement;
      return [{
        prop: 'soft_name',
        default: '',
        label: this.$t('soft_name'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this.form.model.soft_name,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "soft_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'soft_url',
        default: '',
        label: this.$t('soft_url'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this.form.model.soft_url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "soft_url", $$v);
              }
            }
          });
        }
      }, {
        prop: 'soft_url',
        default: '',
        label: this.$t('soft_url'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-file-uploader", {
            "model": {
              value: _this.form.model.soft_url,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "soft_url", $$v);
              }
            }
          });
        }
      }, {
        prop: 'soft_version',
        default: '',
        label: this.$t('soft_version'),
        col: {
          span: 16
        },
        rule: [{
          required: true,
          message: 'required',
          trigger: 'change'
        }, {
          validator: utils.helper.isLegalSoftVersionValidator,
          trigger: 'change'
        }],
        render: function render() {
          return h("el-input", {
            "model": {
              value: _this.form.model.soft_version,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "soft_version", $$v);
              }
            }
          });
        }
      }, {
        prop: 'status',
        default: '',
        label: this.$t('status'),
        col: {
          span: 16
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "screen_app_status"
            },
            "model": {
              value: _this.form.model.status,
              callback: function callback($$v) {
                _this.$set(_this.form.model, "status", $$v);
              }
            }
          });
        }
      }];
    }
  },
  methods: {}
};